<template>
  <div>
      <div v-for="item in keysList" :key="item">      
        <product-bar
          :ref="`productBar_${item}`"
          :item="item"
          :form="form"
          :type="type"
          :isAdd="isAdd"
          @removeRow="removeRow"
          :arr="arr"
          :ProductNameList="ProductNameList"
        ></product-bar>
      </div>
      <a-row type="flex" justify="center">
        <a-col :span="2">
          <a-button type="primary" icon="plus" @click="addRow" :disabled="!isEdit">添加</a-button>
        </a-col>
      </a-row>
    </div>
</template>

<script>
import productBar from './productBar.vue'
export default {
  components:{
    productBar
  },
  computed:{
    isEdit(){
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  props: {
    form: [Object],
    arr: {
      type: Array,
      default: function () {
        return []
      }
    },
    ProductNameList: {
      type: Array,
      default: function () {
        return []
      }
    },
    type:[String]
  },
  data () {
    return {
      id: 0,
      keysList: [],
      productId:'',
      isAdd:false
    }
  },
  created () {
    this.init()
    this.$nextTick(()=>{
      if(this.type === this.$sysInfo.MODAL_MODIFY){
        this.setProductInfo()
      }
    })
  },
  methods: {
    setProductInfo () {
      this.keysList.forEach(item => {
        this.$refs[`productBar_${item}`][0].setData('productName' , this.arr[item]['productName'])
        this.$refs[`productBar_${item}`][0].setData('modules' , this.arr[item]['modules'])
      })
    },
    getProductList () {
      const arr = []
      this.keysList.forEach(item => {
        console.log('bar', this.$refs[`productBar_${item}`])
        const data = {
          productId: this.form.getFieldValue(`productId[${item}]`),
          productName: this.$refs[`productBar_${item}`][0].getData('productName'),
          productPrice: this.form.getFieldValue(`productPrice[${item}]`),
          modules: this.$refs[`productBar_${item}`][0].getData('modules')
        }
        arr.push(data)
      })
      return arr
    },
    // 初始化
    init () {
      this.keysList = []
      this.model = {}
      this.id = 0
      
      const arr = [0]
      if (this.arr.length !== 0) {
        for (let i = 1; i < (this.arr).length; i++) {
          arr.push(i)
          this.id = this.id + 1
        }
      }
      this.keysList = arr
      this.$nextTick(() => {
        this.setProductInfo()
      })
      console.log('arr',this.arr);
      console.log('init',this.keysList);

    },
    // 移除某行
    removeRow (k) {
      if (this.keysList.length === 1) { // 如果存在可以移除所有行的情况，把条件改为this.keysList.length === 0即可
        this.$refs[`productBar_${k}`][0].clear()
        return
      }
      this.keysList = this.keysList.filter(item => item !== k)
      console.log('del',this.keysList);
    },
    // 新增一行
    addRow () {
      this.id = this.id + 1
      this.keysList = this.keysList.concat(this.id)
      this.isAdd = true
      console.log('add',this.keysList);
    },
  }
}
</script>

<style lang="less" scoped>

</style>

